/**
 * priceFormatter
 * @param  {Float} price - raw price from cart
 * @return {String} formatterPrice - price formatted with Irish locale
 */

const priceFormatter = price => {
  let euro = 0;
  if (Number.isInteger(price)) {
    euro = (price / 100).toLocaleString('en-IE', {
      style: 'currency',
      currency: 'EUR',
    });
  }
  return euro;
};

export default priceFormatter;
